import axios from 'axios'

export const state = {
  user: null,
}

export const mutations = {
  SET_USER(state, user) {
    state.user = user
    localStorage.setItem('user', JSON.stringify(user))
  },
  REMOVE_USER(state) {
    state.user = null
    localStorage.removeItem('user')
  },
}

export const actions = {
  authLogin({ commit }, user) {
    user.tokenExpiry = Date.now() + user.validitySeconds * 1000
    setTimeout(() => {
      commit('REMOVE_USER')
    }, user.validitySeconds * 1000)
    commit('SET_USER', user)
  },
  authLogout({ commit }) {
    commit('REMOVE_USER')
  },
  async loadUser({ commit }) {
    const storedUser = localStorage.getItem('user')
    if (storedUser) {
      let user = JSON.parse(storedUser)
      if (Date.now() > user.tokenExpiry) {
        commit('REMOVE_USER')
      } else {
        await axios
          .get(`${window.apiUrl}/admin/account/profile/view.json`, {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          })
          .then((response) => {
            const updatedUser = response.data.user
            user.username = updatedUser.username
            user.fullName = updatedUser.fullName
            user.email = updatedUser.email
            user.themePreference = updatedUser.themePreference
            user.permissions = response.data.strAuthorities
            user.ezemanageUser = response.data.ezemanageUser === true
            commit('SET_USER', user)
            // Set new timeout for remaining time
            const remainingTime = user.tokenExpiry - Date.now()
            setTimeout(() => {
              commit('REMOVE_USER')
            }, remainingTime)
          })
      }
    }
  },
}

export const getters = {
  isAuthenticated: (state) => !!state.user,
  authUser: (state) => state.user,
  authUserHasPermission: (state) => (permission) => {
    return state.user?.permissions?.includes(permission)
  },
  authUserIsEzemanage: (state) => state.user?.ezemanageUser === true,
}
